import { format } from "date-fns";

/** Notion-style version timestamp, e.g. "June 26 · 9:56 AM". */
export function formatVersionHistoryDate(
  value: Date | string | number,
): string {
  try {
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return format(date, "MMMM d · h:mm a");
  } catch {
    return "";
  }
}
